<template>
  <ProtocolPage type="privacy" />
</template>

<script>
import ProtocolPage from '../ProtocolPage.vue'

export default {
  name: 'PrivacyProtocol',
  components: {
    ProtocolPage
  }
}
</script>
